// Which sessions' question docks he minimized (QuestionDock.tsx), for the
// page's life. Apart from the dock, so that the tests' setup can forget them
// without loading the dock, its card and what that card renders with.

/** The sessions whose dock he minimized. */
export const minimized = new Set<string>()

/** Forget them all: for the tests. */
export function forgetDocks(): void {
  minimized.clear()
}
